import React from "react";

function HotelBooking() {
  return <div>HotelBooking</div>;
}

export default HotelBooking;
